import * as React from "react";
import {BonusConfig} from "../../../../generated/protocol";
import {RouterView, LoadingViewState} from "../RouterView";
import {Form, FormListener} from "../../form/Form";
import {Validators} from "../../form/Validators";
import {FormGroup} from "../../form/FormGroup";
import {FormInput, FractionInput} from "../../form/FormInput";
import {FormTextArea} from "../../form/FormTextArea";
import {BonusService, BONUS_SERVICE_NAME} from "../../../service/bonus/BonusService";
import {Switch, Case} from "../../form/Switch";
import {RequiresAdminRole} from "../../util/RequiresAdminRole";
import {kernel} from "../../../ioc/IOCHelper";


interface State extends LoadingViewState {
    bonus?: BonusConfig;
    validationMap?: any;
}

const initialState = {validationMap: {}, bonus: {}};

export class BonusConfigView extends RouterView<{ params: { id: string } }, State> implements FormListener<BonusConfig> {

    bonusService: BonusService;

    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.state, initialState);
        this.bonusService = kernel.get<BonusService>(BONUS_SERVICE_NAME);
    }

    loadContent(): Promise<any> {
        return this.init();
    }

    init() {
        return this.loadAll(
            this.bonusService.getEntity(this.props.params.id),
        ).then(results => {
            this.setState({
                bonus: results[0],
            });
        })
    }

    onSubmitError?: () => void;
    onSubmit: () => void | Promise<any>;
    formDidUpdate(formModel: BonusConfig, validationMap: any) {
        this.setState({bonus: formModel, validationMap: validationMap});
    }

    getMaxAmountLabel() {
        if (this.state.bonus.type == "FIXED_AMOUNT") {
            return "Award Amount";
        } else {
            return "Max Amount"
        }
    }

    renderContent() {
        return (
            <div>
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h1>Bonus Config</h1>
                    </div>
                </div>
                <div className="wrapper wrapper-content animated">
                    <Form className="form-horizontal" formListener={this} modelObject={this.state.bonus} validationMap={this.state.validationMap}>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox float-e-margins">
                                    <div className="ibox-title">
                                        <h5>Bonus Info</h5>
                                    </div>
                                    <div className="ibox-content">
                                        <div className="hr-line-dashed"></div>

                                        <FormGroup className="form-group" model="nameId">
                                            <label className="col-sm-2 control-label">Name ID</label>
                                            <div className="col-sm-10">
                                                <FormInput type="text" model="nameId" className="form-control" disabled/>
                                                <span className="help-block m-b-none">
                                                    Unique id for a bonus example: cubiea_top_winners_xcc
                                                </span>
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>

                                        <RequiresAdminRole>
                                            <FormGroup className="form-group" model="createdByOperatorId">
                                                <label className="col-sm-2 control-label">Operator ID</label>
                                                <div className="col-sm-10">
                                                    <FormInput type="text" model="createdByOperatorId"
                                                               className="form-control" disabled/>
                                                    <span className="help-block m-b-none">
                                                    The id of the operator that owns this leaderboard (can edit)
                                                </span>
                                                </div>
                                            </FormGroup>
                                            <div className="hr-line-dashed"></div>
                                        </RequiresAdminRole>

                                        <FormGroup className="form-group" model="name">
                                            <label className="col-sm-2 control-label">Name</label>
                                            <div className="col-sm-10">
                                                <FormInput type="text" model="name"
                                                           validators={[Validators.required(), Validators.textInput()]}
                                                           className="form-control" disabled/>
                                                <span className="help-block m-b-none">
                                                    The name displayed to players
                                                </span>
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>

                                        <FormGroup className="form-group" model="description">
                                            <label className="col-sm-2 control-label">Description</label>
                                            <div className="col-sm-10">
                                                <FormTextArea type="text" model="description"
                                                              validators={[Validators.textInput()]}
                                                              className="form-control" disabled/>
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>

                                        <div className="form-group">
                                            <label className="col-sm-2 control-label">Active</label>
                                            <div className="col-sm-10">
                                                <FormInput type="checkbox" model="active" disabled/>
                                                <span className="help-block m-b-none">
                                                    Enable/disable this bonus
                                                </span>
                                            </div>
                                        </div>
                                        <div className="hr-line-dashed"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox float-e-margins">
                                    <div className="ibox-title">
                                        <h5>Bonus Settings</h5>
                                    </div>
                                    <div className="ibox-content">

                                        <div className="hr-line-dashed"></div>

                                        <FormGroup className="form-group" model="game">
                                            <label className="col-sm-2 control-label">Game</label>
                                            <div className="col-sm-10">
                                                <FormInput className="form-control" model="game" disabled/>
                                                <span className="help-block m-b-none">
                                                   'poker' or empty for all events
                                                </span>
                                            </div>
                                        </FormGroup>

                                        <FormGroup className="form-group" model="type">
                                            <label className="col-sm-2 control-label">Type</label>
                                            <div className="col-sm-10">
                                                <FormInput className="form-control" model="type" disabled/>
                                                <span className="help-block m-b-none">
                                                    Fixed amount bonuses will always give the player the same amount in bonus.
                                                    Dynamic amount bonuses will give the player a percentage of the amount you activate it with.
                                                </span>
                                            </div>
                                        </FormGroup>

                                        <Switch value={this.state.bonus.type}>
                                            <Case value="DYNAMIC_AMOUNT">
                                                <div className="hr-line-dashed"></div>
                                                <FormGroup className="form-group" model="bonusAmountFraction">
                                                    <label className="col-sm-2 control-label">Award % amount</label>
                                                    <div className="col-sm-10">
                                                        <FractionInput model="bonusAmountFraction" className="form-control" disabled/>
                                                        <span className="help-block m-b-none">
                                                    The percentage of the activation amount that should be used for this bonus (eg 200% deposit bonus should be set to 200)
                                                </span>
                                                    </div>
                                                </FormGroup>
                                            </Case>
                                        </Switch>

                                        <div className="hr-line-dashed"></div>

                                        <FormGroup className="form-group" model="maxAmount">
                                            <label className="col-sm-2 control-label">{this.getMaxAmountLabel()}</label>
                                            <div className="col-sm-10">
                                                <FormInput type="text" model="maxAmount" className="form-control" disabled/>
                                                <Switch value={this.state.bonus.type}>
                                                    <Case value="FIXED_AMOUNT">
                                                        <span className="help-block m-b-none">The amount that should be awarded by this bonus</span>
                                                    </Case>
                                                    <Case value="DYNAMIC_AMOUNT">
                                                        <span className="help-block m-b-none">The maximum amount that can be awarded from this bonus</span>
                                                    </Case>
                                                </Switch>
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>

                                        <FormGroup className="form-group" model="currencyCode">
                                            <label className="col-sm-2 control-label">Currency</label>
                                            <div className="col-sm-10">
                                                <FormInput type="text" className="form-control" model="currencyCode" disabled/>
                                                <span className="help-block m-b-none">
                                                    The currency to award the bonus in
                                                </span>
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>

                                        <div className="form-group">
                                            <label className="col-sm-2 control-label">Transfer bonus</label>
                                            <div className="col-sm-10">
                                                <FormInput type="checkbox" model="transferBonusAmount" disabled/>
                                                <span className="help-block m-b-none">
                                                    If the bonus should take care of transferring bonus money or not, usually it should.
                                                    Some times a tournament pays out bonus money and in that case it should not be ticked
                                                </span>
                                            </div>
                                        </div>

                                        <div className="hr-line-dashed"></div>

                                        <div className="form-group">
                                            <label className="col-sm-2 control-label">Allow multiple activations</label>
                                            <div className="col-sm-10">
                                                <FormInput type="checkbox" model="multipleActivations" disabled/>
                                                <span className="help-block m-b-none">
                                                   If a player should be able to receive this bonus multiple times
                                                </span>
                                            </div>
                                        </div>

                                        <div className="hr-line-dashed"></div>

                                        <FormGroup className="form-group" model="levelBonusConversionName">
                                            <label className="col-sm-2 control-label">Bonus Conversion</label>
                                            <div className="col-sm-10">
                                                <FormInput type="text" className="form-control" model="levelBonusConversionName" disabled/>
                                                <span className="help-block m-b-none">
                                                    How much of the bonus amount should be awarded as real money on activation
                                                </span>
                                            </div>
                                        </FormGroup>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox float-e-margins">
                                    <div className="ibox-title">
                                        <h5>Release Configuration</h5>
                                    </div>
                                    <div className="ibox-content">
                                        <div className="form-group">
                                            <div className="col-sm-10 col-sm-offset-2">
                                                <div className="panel panel-default">
                                                    <div className="panel-heading">
                                                        <i className="fa fa-lightbulb-o"></i> Help
                                                    </div>
                                                    <div className="panel-body">
                                                        <p>
                                                            This configures how much and how often the credit in the
                                                            bonus account will be transferred to the main account for
                                                            this bonus.
                                                            <br/><br/>
                                                            Example: You have a bonus that gives the a player 10 USD to
                                                            his main account and 10 USD to his bonus account.
                                                            For every 1 USD in rake the player accumulates you want to
                                                            transfer 2 USD from his bonus account to his main account.
                                                            <br/>For
                                                            every <strong>1</strong> in <strong>rake</strong> release <strong>2</strong>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <FormGroup className="form-group" model="release.every">
                                            <label className="col-sm-2 control-label">For every</label>
                                            <div className="col-sm-10">
                                                <FormInput className="form-control" model="release.every" disabled/>
                                                <span className="help-block m-b-none">
                                                    The sum in <strong>{this.state.bonus.valueAttribute}</strong> to reach 
                                                    to release money from a players bonus account to his main account
                                                </span>
                                            </div>
                                        </FormGroup>

                                        <FormGroup className="form-group" model="valueAttribute">
                                            <label className="col-sm-2 control-label">in</label>
                                            <div className="col-sm-10">
                                                <FormInput type="text" className="form-control" model="valueAttribute" disabled/>
                                                <span className="help-block m-b-none">
                                                    What poker value you want to accumulate
                                                </span>
                                            </div>
                                        </FormGroup>

                                        <FormGroup className="form-group" model="release.amount">
                                            <label
                                                className="col-sm-2 control-label">{"release (" + this.state.bonus.currencyCode + ")"}</label>
                                            <div className="col-sm-10">
                                                <FormInput className="form-control" model="release.amount" disabled/>
                                                <span className="help-block m-b-none">
                                                    The amount of bonus in {this.state.bonus.currencyCode} to release each time the user
                                                    accumulates {this.state.bonus.release ? this.state.bonus.release.every : "-"} in {this.state.bonus.valueAttribute}
                                                </span>
                                            </div>
                                        </FormGroup>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/app/ui/view/bonus/BonusConfigView.tsx